let Preload = {}

const loop = function () {}

class PreloadResource {
  constructor (manifest = [], vue) {
    this.$vue = vue
    this.resources = []
    this.loadProgress = loop
    this.loadComplete = loop
    if (Array.isArray(manifest)) {
      manifest.forEach(element => {
        this.addImage(element)
      })
    }
  }

  addImage ({ id, src, lazyload } = {}) {
    if (id && src && !lazyload) {
      let obj = {
        id,
        src: require('@/' + src)
      }
      this.resources.push(obj)
    } else {
      this.$vue.$store.dispatch('addResource', {
        id,
        lazyload,
        src: require('@/' + src)
      })
    }
  }

  addLoadProgress (callback = loop) {
    this.loadProgress = callback
  }

  addLoadComplete (callback = loop) {
    this.loadComplete = callback
  }

  start () {
    let { resources } = this
    let total = resources.length
    let loaded = 0
    let self = this
    for (let i = 0, len = resources.length; i < len; i++) {
      (function (_index) {
        let { id, src } = resources[_index]
        let image = new Image()

        image.onload = function () {
          if (image.complete) {
            image.onload = null
            image.id = id
            loaded++

            self.$vue.$store.dispatch('addResource', { id, src, image })

            if (loaded === total) {
              self.loadComplete(id, src, loaded, total)
            } else {
              self.loadProgress(loaded, total)
            }
          }
        }
        image.src = src
      })(i)
    }
  }
}
Preload.install = function (Vue, options) {
  Vue.PreloadResource = Vue.prototype.PreloadResource = function (manifest) {
    return new PreloadResource(manifest, this)
  }
}

export default Preload
